
import { useEffect, useState } from "react";
import { Menu,Collapse ,Card,List,Spin,Table,Button} from 'antd';
import AsamaPerformansRaporSurecListesi from '../../services/asamaPerformansRaporSurecListesi';
import AsamaPerformansRaporSorgula from '../../services/asamaPerformansRaporSorgula';
import ExcelExport from "../ExcelExport";
import { FileExcelOutlined,OrderedListOutlined } from "@ant-design/icons";


const BasvuruAltSurecStateRapor = () => {

    const { Panel } = Collapse;

    const [spining, setSpining] = useState(false);
    const[visible,setVisible] = useState(false);

    const[altSurecList,setAltSurecList] = useState([]);
    const[surecAdi,setSurecAdi] = useState();
    const[basvuruStateList,setBasvuruStateList] = useState([]);

   

    const load = async () => {
      setSpining(true);
      await AsamaPerformansRaporSurecListesi().then(resp => {
        setAltSurecList(resp.data.result);
      });
      setSpining(false);
    }

    const loadTable = async(altSurecTipiId,stateId) => {
      setBasvuruStateList([]);
      setSpining(true);
      
      await AsamaPerformansRaporSorgula(altSurecTipiId,stateId)
          .then(res => { setBasvuruStateList(sortData(res.data.result));  setVisible(true); });      

      setSpining(false);

    }

    useEffect(() => {
      load();
    },[]) 

    const columns = [
      {
        title: 'Ana başvuru no',
        dataIndex: 'parentObjectId',
        key: 'parentObjectId',
      },
      {
        title: 'Basvuru no',
        dataIndex: 'basvuruId',
        key: 'basvuruId',
      },
      {
        title: 'Belge türü',
        dataIndex: 'belgeTuruAdi',
        key: 'belgeTuruAdi',
      },
      {
        title: 'Alt süreç',
        dataIndex: 'altSurecAdi',
        key: 'altSurecAdi',
      },
      {
        title: 'Mahalle',
        dataIndex: 'mahalle',
        key: 'mahalle',
      },
      {
        title: 'Ada/parsel',
        dataIndex: 'adaParsel',
        key: 'adaParsel',
      },
      {
        title: 'Mevcut Aşama',
        dataIndex: 'currentState',
        key: 'currentState',
      },
      {
        title: 'Sorumlu',
        dataIndex: 'sorumluKullanici',
        key: 'sorumluKullanici',
      },
      {
        title: 'Süre',
        dataIndex: 'gecenSure',
        key: 'gecenSure',
      },
      {
        title: 'Saat',
        dataIndex: 'gecenSaat',
        key: 'gecenSaat',
        defaultSortOrder: 'descend',
        sorter: {
          compare: (a, b) => a.gecenSaat - b.gecenSaat,
         // compare: Sorter.DEFAULT,
          multiple: 1,
        }
      }
    ];

    const sortData = (data) => {
      // Call slice to create a new Array and prevent mutating it if it's stored in state
      return data.slice().sort((a, b) => a.gecenSaat - b.gecenSaat).reverse();
   }

   
    return (
      <Spin tip={"Veriler Yükleniyor"} spinning={spining} >
        <Card
          style={{ margin: "20px" }}
          title={<h4 style={{ fontWeight: "bolder", color: "white" }}>Aşama Performans Rapor</h4>}
          className="ant-card-head-title-large">
          <Collapse accordion>
            {altSurecList.map( key => (
                <Panel header={key.AltSurecAdi} key={key.AltSurecId}>
                      <List
                          itemLayout="horizontal"
                          dataSource={key.StateList}
                          renderItem={(item) => (
                              <Button type="text" style={{width:'100%', textAlign:'left'}}  onClick={() => { setSurecAdi(key.AltSurecAdi + "/" + item.stateDescription);loadTable(key.AltSurecId,item.stateId); }}>
                                {item.stateDescription}
                              </Button>
                          )}
                        />
                </Panel>
            ))}         
          
          </Collapse>

          {visible && 
          <> 
            <Table   
              columns={columns}
              dataSource={basvuruStateList}              
              bordered
              rowKey={"key"}          
              title={() => <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h3 style={{ fontWeight: "bolder" }}> {surecAdi}</h3>
                <ExcelExport
                  fileName={'Aşama Performans Raporu' }
                  downloadButton={<Button type="link" icon={<FileExcelOutlined style={{ color: "green" }} />}> Excele Aktar </Button>}
                  sheets={[{ data: basvuruStateList, name: 'Rapor', keyTitles: columns }]} />                
                </div>
            }
            pagination={{
              showSizeChanger: true
            }}            
            scroll={{ y: 750 }}
            />   
          </>
             
          }
          </Card>

          
        </Spin>
      );

    };



export default BasvuruAltSurecStateRapor;